import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { WheelAlignmentInfoLightBoxActions } from '../constants/wheel_alignment_info_light_box/wheel_alignment_info_light_box_actions';

class WheelAlignmentInfoLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            expanded: false,
        };
    }

    reduce(state, {source, action}) {
        if (source === ACTION_TYPES.WHEEL_ALIGNMENT_INFO_LIGHTBOX_ACTION) {
            switch (action.type) {
                case WheelAlignmentInfoLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        this.__emitChange();
                    }

                    break;

                case WheelAlignmentInfoLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        this.__emitChange();
                    }

                    break;

                case WheelAlignmentInfoLightBoxActions.EXPAND:
                    if (!state.expanded) {
                        state.expanded = true;
                        this.__emitChange();
                    }

                    break;
            }
        }

        return state;
    }
}

const WheelAlignmentInfoLightBoxStore = new WheelAlignmentInfoLightBoxStoreClass(Dispatcher);
export { WheelAlignmentInfoLightBoxStore };
